import { useEffect } from 'react'

import { ErrorScreen } from '@/Ship/Components/AccessDenied'

/**
 * 404 (`SPEC-014` §2.3): картинка й «На головну» легасі (`Error404Page.jsx`).
 *
 * Відкривається будь-якою невідомою адресою — маршрут `*` у `main.tsx`, — а
 * не лише `/public/error404`: без нього react-router показував власну
 * англомовну помилку. Текст українською прямо тут: ключа `To Home page` у
 * перекладах немає, і PD показував його англійською.
 *
 * «На головну» — повне перезавантаження на `/`, як у легасі: так з
 * публічного шаблону потрапляють у каркас, а неавторизований — на вхід.
 */
export default function Error404Page() {
    useEffect(() => {
        document.title = 'Сторінку не знайдено'
    }, [])

    return <ErrorScreen image="/assets/errors/error404.svg" title="Сторінку не знайдено" />
}
